var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#E9EDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36607 8.114C9.21187 7.868 9.06474 7.52 9.00118 7H16C15.9376 7.52 15.7905 7.868 15.6375 8.114C15.4432 8.424 15.1831 8.664 14.8347 8.919C14.7052 9.014 14.5887 9.094 14.4545 9.186L14.2356 9.337C13.9801 9.50929 13.739 9.6964 13.514 9.897C12.9749 10.385 12.5018 11.062 12.5018 12C12.5018 11.062 12.0274 10.385 11.4895 9.897C11.2645 9.6964 11.0234 9.50929 10.768 9.337L10.549 9.187C10.4137 9.094 10.2971 9.014 10.1676 8.919C9.81924 8.663 9.55911 8.424 9.36607 8.114ZM15.9976 17H9C9.06356 16.481 9.21187 16.133 9.36489 15.886C9.55911 15.576 9.82041 15.336 10.1688 15.081C10.2983 14.986 10.4137 14.906 10.549 14.814L10.768 14.662C10.981 14.514 11.2447 14.325 11.4895 14.102C12.0286 13.615 12.5018 12.939 12.5018 12C12.5018 12.937 12.9738 13.614 13.5117 14.102C13.7565 14.325 14.0202 14.514 14.2332 14.662L14.4522 14.813C14.5863 14.905 14.7029 14.985 14.8324 15.08C15.1796 15.336 15.4409 15.575 15.6339 15.886C15.7881 16.132 15.9341 16.481 15.9976 17Z",
    fill: "#4462EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomTime);
export default __webpack_public_path__ + "static/media/zoom-time.5bd25fb824ee5e77713ac9c363e87829.svg";
export { ForwardRef as ReactComponent };